// Audit log API fetcher — Wave E. Backed by GET /api/v1/activity-log.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type { ActivityLogListResponse } from '../types/api';

export interface AuditLogFilters {
  page: number;
  limit?: number;
  action?: string;
  staff_id?: number;
  entity_type?: string;
  date_from?: string;
  date_to?: string;
}

export async function listAuditLog(
  filters: AuditLogFilters,
): Promise<ActivityLogListResponse> {
  const params = new URLSearchParams();
  params.set('page', String(filters.page));
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.action) params.set('action', filters.action);
  if (filters.staff_id) params.set('staff_id', String(filters.staff_id));
  if (filters.entity_type) params.set('entity_type', filters.entity_type);
  if (filters.date_from) params.set('date_from', filters.date_from);
  if (filters.date_to) params.set('date_to', filters.date_to);
  const res = await apiClient.get<ActivityLogListResponse>(
    `${endpoints.activityLog.list}?${params.toString()}`,
  );
  return res.data;
}
